import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { OrderTracker } from "@/components/OrderTracker";
import { RestaurantAddress } from "@/components/RestaurantAddress";
import { ReceiptEmail } from "@/components/ReceiptEmail";
import { ChefHat, Loader2 } from "lucide-react";
import { useT } from "@/lib/i18n";
import { LanguagePicker } from "@/components/LanguagePicker";

export default function OrderTrack() {
  const { t } = useT();
  const { orderId } = useParams();
  const [restaurant, setRestaurant] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/orders/${orderId}`)
      .then((r) => api.get(`/restaurants/${r.data.restaurant_id}`).then((rr) => setRestaurant(rr.data)))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [orderId]);

  const accent = restaurant?.primary_color || "#D9531E";

  if (loading)
    return (
      <div className="min-h-screen grid place-items-center bg-[#FAF7F2]">
        <Loader2 className="h-8 w-8 animate-spin" style={{ color: accent }} />
      </div>
    );

  if (notFound)
    return (
      <div className="min-h-screen grid place-items-center bg-[#FAF7F2] text-center px-6">
        <div>
          <ChefHat className="h-12 w-12 mx-auto text-[#D9531E]" />
          <h1 className="font-heading text-2xl font-bold mt-4 text-[#1F1D1B]">{t("orderNotFound")}</h1>
          <p className="text-[#6B6560] mt-2">{t("orderNotFoundDesc")}</p>
        </div>
      </div>
    );

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[#FAF7F2] px-5 py-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-12 w-12 rounded-2xl overflow-hidden bg-white grid place-items-center shadow">
          {restaurant?.logo_path ? <img src={fileUrl(restaurant.logo_path)} alt="logo" className="h-full w-full object-cover" /> : <ChefHat className="h-6 w-6" style={{ color: accent }} />}
        </div>
        <div className="flex-1 min-w-0">
          <h1 className="font-heading text-xl font-bold text-[#1F1D1B]">{restaurant?.name}</h1>
          <p className="text-xs text-[#6B6560]">{t("liveStatus")}</p>
        </div>
        <LanguagePicker />
      </div>
      <OrderTracker orderId={orderId} accent={accent} />
      <RestaurantAddress restaurant={restaurant} accent={accent} className="mt-4" />
      <div className="mt-4"><ReceiptEmail orderId={orderId} accent={accent} /></div>
      <p className="text-xs text-center text-[#6B6560] mt-6">{t("autoUpdate")}</p>
    </div>
  );
}
